module.exports = __webpack_public_path__ + "img/9788954611862.26811bea.jpg";